"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Select = Select;
exports.SelectContent = SelectContent;
exports.SelectGroup = SelectGroup;
exports.SelectItem = SelectItem;
exports.SelectLabel = SelectLabel;
exports.SelectScrollDownButton = SelectScrollDownButton;
exports.SelectScrollUpButton = SelectScrollUpButton;
exports.SelectSeparator = SelectSeparator;
exports.SelectTrigger = SelectTrigger;
exports.SelectValue = SelectValue;
var React = _interopRequireWildcard(require("react"));
var _utils = require("@design/lib/utils");
var _radixUi = require("radix-ui");
var _materialSymbols = require("@design/icons/material-symbols");
var _truncatedText = require("@design/ui/truncated-text");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["className"],
  _excluded2 = ["className", "size", "children"],
  _excluded3 = ["className", "children", "position", "align"],
  _excluded4 = ["className"],
  _excluded5 = ["className", "children"],
  _excluded6 = ["className"],
  _excluded7 = ["className"],
  _excluded8 = ["className"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectDestructuringEmpty(t) { if (null == t) throw new TypeError("Cannot destructure " + t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function Select(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_radixUi.Select.Root, _objectSpread(_objectSpread({
    "data-slot": "select"
  }, props), {}, {
    "data-sentry-element": "SelectPrimitive.Root",
    "data-sentry-component": "Select",
    "data-sentry-source-file": "select.tsx"
  }));
}
function SelectGroup(_ref2) {
  var className = _ref2.className,
    props = _objectWithoutProperties(_ref2, _excluded);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_radixUi.Select.Group, _objectSpread(_objectSpread({
    "data-slot": "select-group",
    className: (0, _utils.cn)("scroll-my-1 p-1", className)
  }, props), {}, {
    "data-sentry-element": "SelectPrimitive.Group",
    "data-sentry-component": "SelectGroup",
    "data-sentry-source-file": "select.tsx"
  }));
}
function SelectValue(_ref3) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref3), _ref3));
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_truncatedText.TruncatedText, {
    "data-slot": "select-value",
    "data-sentry-element": "TruncatedText",
    "data-sentry-component": "SelectValue",
    "data-sentry-source-file": "select.tsx",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_radixUi.Select.Value, _objectSpread(_objectSpread({
      className: "contents"
    }, props), {}, {
      "data-sentry-element": "SelectPrimitive.Value",
      "data-sentry-source-file": "select.tsx"
    }))
  });
}
function SelectTrigger(_ref4) {
  var className = _ref4.className,
    _ref4$size = _ref4.size,
    size = _ref4$size === void 0 ? "default" : _ref4$size,
    children = _ref4.children,
    props = _objectWithoutProperties(_ref4, _excluded2);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_radixUi.Select.Trigger, _objectSpread(_objectSpread({
    "data-slot": "select-trigger",
    "data-size": size,
    className: (0, _utils.cn)("flex w-fit items-center justify-between gap-2 rounded-(--component-base-radius) border border-input bg-input-fill px-(--component-base-px) py-2 text-sm whitespace-nowrap transition-[color,box-shadow] outline-none hover:bg-input-hover focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/50 disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-3 aria-invalid:ring-destructive/20 data-placeholder:text-muted-foreground h-(--component-base-height) data-[size=sm]:h-8 dark:aria-invalid:border-destructive/50 dark:aria-invalid:ring-destructive/40 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4", className)
  }, props), {}, {
    "data-sentry-element": "SelectPrimitive.Trigger",
    "data-sentry-component": "SelectTrigger",
    "data-sentry-source-file": "select.tsx",
    children: [children, /*#__PURE__*/(0, _jsxRuntime.jsx)(_radixUi.Select.Icon, {
      asChild: true,
      "data-sentry-element": "SelectPrimitive.Icon",
      "data-sentry-source-file": "select.tsx",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.KeyboardArrowDownIcon, {
        className: "pointer-events-none size-4 text-muted-foreground",
        "data-sentry-element": "KeyboardArrowDownIcon",
        "data-sentry-source-file": "select.tsx"
      })
    })]
  }));
}
function SelectContent(_ref5) {
  var className = _ref5.className,
    children = _ref5.children,
    _ref5$position = _ref5.position,
    position = _ref5$position === void 0 ? "item-aligned" : _ref5$position,
    _ref5$align = _ref5.align,
    align = _ref5$align === void 0 ? "center" : _ref5$align,
    props = _objectWithoutProperties(_ref5, _excluded3);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_radixUi.Select.Portal, {
    "data-sentry-element": "SelectPrimitive.Portal",
    "data-sentry-component": "SelectContent",
    "data-sentry-source-file": "select.tsx",
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_radixUi.Select.Content, _objectSpread(_objectSpread({
      "data-slot": "select-content",
      "data-align-trigger": position === "item-aligned",
      className: (0, _utils.cn)("relative z-floating max-h-(--radix-select-content-available-height) min-w-36 origin-(--radix-select-content-transform-origin) overflow-x-hidden overflow-y-auto rounded-lg bg-background-surface p-1 text-popover-foreground shadow-md ring-1 ring-black/5 duration-100 data-[align-trigger=true]:animate-none data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 data-open:animate-in data-open:fade-in-0 data-open:zoom-in-95 data-closed:animate-out data-closed:fade-out-0 data-closed:zoom-out-95", position === "popper" && "data-[side=bottom]:translate-y-1 data-[side=left]:-translate-x-1 data-[side=right]:translate-x-1 data-[side=top]:-translate-y-1", className),
      position: position,
      align: align
    }, props), {}, {
      "data-sentry-element": "SelectPrimitive.Content",
      "data-sentry-source-file": "select.tsx",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(SelectScrollUpButton, {
        "data-sentry-element": "SelectScrollUpButton",
        "data-sentry-source-file": "select.tsx"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_radixUi.Select.Viewport, {
        "data-position": position,
        className: (0, _utils.cn)("data-[position=popper]:h-(--radix-select-trigger-height) data-[position=popper]:w-full data-[position=popper]:min-w-(--radix-select-trigger-width)", position === "popper" && ""),
        "data-sentry-element": "SelectPrimitive.Viewport",
        "data-sentry-source-file": "select.tsx",
        children: children
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(SelectScrollDownButton, {
        "data-sentry-element": "SelectScrollDownButton",
        "data-sentry-source-file": "select.tsx"
      })]
    }))
  });
}
function SelectLabel(_ref6) {
  var className = _ref6.className,
    props = _objectWithoutProperties(_ref6, _excluded4);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_radixUi.Select.Label, _objectSpread(_objectSpread({
    "data-slot": "select-label",
    className: (0, _utils.cn)("px-2 py-1.5 text-sm text-muted-foreground", className)
  }, props), {}, {
    "data-sentry-element": "SelectPrimitive.Label",
    "data-sentry-component": "SelectLabel",
    "data-sentry-source-file": "select.tsx"
  }));
}
function SelectItem(_ref7) {
  var className = _ref7.className,
    children = _ref7.children,
    props = _objectWithoutProperties(_ref7, _excluded5);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_radixUi.Select.Item, _objectSpread(_objectSpread({
    "data-slot": "select-item",
    className: (0, _utils.cn)("relative flex w-full cursor-default items-center gap-2 rounded-lg p-2 pr-8 text-sm outline-hidden select-none focus:bg-accent focus:text-accent-foreground not-data-[variant=destructive]:focus:**:text-accent-foreground data-disabled:pointer-events-none data-disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4 *:[span]:last:flex *:[span]:last:items-center *:[span]:last:gap-2", className)
  }, props), {}, {
    "data-sentry-element": "SelectPrimitive.Item",
    "data-sentry-component": "SelectItem",
    "data-sentry-source-file": "select.tsx",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: "pointer-events-none absolute right-2 flex size-4 items-center justify-center",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_radixUi.Select.ItemIndicator, {
        "data-sentry-element": "SelectPrimitive.ItemIndicator",
        "data-sentry-source-file": "select.tsx",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.CheckIcon, {
          className: "pointer-events-none",
          "data-sentry-element": "CheckIcon",
          "data-sentry-source-file": "select.tsx"
        })
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_radixUi.Select.ItemText, {
      "data-sentry-element": "SelectPrimitive.ItemText",
      "data-sentry-source-file": "select.tsx",
      children: children
    })]
  }));
}
function SelectSeparator(_ref8) {
  var className = _ref8.className,
    props = _objectWithoutProperties(_ref8, _excluded6);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_radixUi.Select.Separator, _objectSpread(_objectSpread({
    "data-slot": "select-separator",
    className: (0, _utils.cn)("pointer-events-none -mx-1 my-1 h-px bg-border", className)
  }, props), {}, {
    "data-sentry-element": "SelectPrimitive.Separator",
    "data-sentry-component": "SelectSeparator",
    "data-sentry-source-file": "select.tsx"
  }));
}
function SelectScrollUpButton(_ref9) {
  var className = _ref9.className,
    props = _objectWithoutProperties(_ref9, _excluded7);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_radixUi.Select.ScrollUpButton, _objectSpread(_objectSpread({
    "data-slot": "select-scroll-up-button",
    className: (0, _utils.cn)("z-10 flex cursor-default items-center justify-center bg-popover py-1 [&_svg:not([class*='size-'])]:size-4", className)
  }, props), {}, {
    "data-sentry-element": "SelectPrimitive.ScrollUpButton",
    "data-sentry-component": "SelectScrollUpButton",
    "data-sentry-source-file": "select.tsx",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.KeyboardArrowUpIcon, {
      "data-sentry-element": "KeyboardArrowUpIcon",
      "data-sentry-source-file": "select.tsx"
    })
  }));
}
function SelectScrollDownButton(_ref0) {
  var className = _ref0.className,
    props = _objectWithoutProperties(_ref0, _excluded8);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_radixUi.Select.ScrollDownButton, _objectSpread(_objectSpread({
    "data-slot": "select-scroll-down-button",
    className: (0, _utils.cn)("z-10 flex cursor-default items-center justify-center bg-popover py-1 [&_svg:not([class*='size-'])]:size-4", className)
  }, props), {}, {
    "data-sentry-element": "SelectPrimitive.ScrollDownButton",
    "data-sentry-component": "SelectScrollDownButton",
    "data-sentry-source-file": "select.tsx",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.KeyboardArrowDownIcon, {
      "data-sentry-element": "KeyboardArrowDownIcon",
      "data-sentry-source-file": "select.tsx"
    })
  }));
}